import Api from "./axiosVersion1";

export const descriptionUpdate = async ({ card_id, data }) => {
    return await Api.put(`/card/${card_id}`,data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
  };
